import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 120000, // 120s — AI image generation can take 60-90s on slow days
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("glam_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/**
 * Downscale + recompress an image to a max edge of `maxEdge` px and JPEG quality `quality`.
 * Returns a data-URI base64 string. Falls back to the original file if anything fails.
 * Keeps the payload small enough to upload reliably on mobile networks
 * while preserving enough detail for AI analysis.
 */
export const compressImage = (file, maxEdge = 1600, quality = 0.85) =>
  new Promise((resolve) => {
    if (!file || !file.type?.startsWith("image/")) return resolve(null);
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        try {
          const scale = Math.min(1, maxEdge / Math.max(img.width, img.height));
          const w = Math.round(img.width * scale);
          const h = Math.round(img.height * scale);
          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL("image/jpeg", quality));
        } catch {
          resolve(reader.result); // fallback: original
        }
      };
      img.onerror = () => resolve(reader.result);
      img.src = reader.result;
    };
    reader.onerror = () => resolve(null);
    reader.readAsDataURL(file);
  });
